// Module
var code = "<cd-billing-item-slider flex ng-if=\"billingItemGroup[billingItemGroup.length-1].end != null\" ng-change=\"vm.calculateBudgetEstimate()\" ng-disabled=\"!billingItemGroup.include\" ng-model=\"billingItemGroup.quantity\" billing-item-group=\"billingItemGroup\"/> ";
// Exports
var _module_exports = code;;
var path = 'views/marketplace/marketplace-product-billing-items-common.slider.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;